import * as React from "react";
import {
  amenityContainer,
  centerDiv,
  amenity,
  tile,
  showMoreLessContainer,
  showMoreLessButton,
} from "./Amenities.module.scss";
import Amenity from "./helperComponents/Amenity/Amenity";

export const AmenityContainer: React.FC<any> = (props) => {
  return (
    <ul
      className={amenityContainer}
      ref={props.containerRef}
      onScroll={props.onScroll}
    >
      {props.children}
    </ul>
  );
};
export const CenterDiv: React.FC<any> = (props) => {
  return <div className={centerDiv}>{props.children}</div>;
};

export const AmenityColumns: React.FC<any> = (props) => {
  const { amenities, amenitiesShowCount, color } = props;
  return amenities
    .slice(0, amenitiesShowCount)
    .map((a: { machine_name: string; name: string | null | undefined }) => {
      return (
        <li className={amenity} key={a.machine_name}>
          <div className={tile}>
            <Amenity icon={a.machine_name} color={color || "#404040"} />
            {a.name}
          </div>
        </li>
      );
    });
};

export const ShowMoreLessButton: React.FC<{
  children: any;
  color: string;
  onClick: (e: any) => void;
}> = (props) => {
  return (
    <div className={showMoreLessContainer}>
      <div
        className={showMoreLessButton}
        style={{
          textDecorationColor: props.color,
        }}
        onClick={props.onClick}
      >
        {props.children}
      </div>
    </div>
  );
};
